/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { BaseError } from '../../shared/errors/Errors';

interface Props {
	error: BaseError | null;
}

interface State {
	open: boolean;
}

class AuthErrorDialogView extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			open: false
		};
	}

	componentDidUpdate(): void {
		const { error } = this.props;
		const { open } = this.state;
		if (!open && error) {
			this.setState({
				open: true
			});
		}
	}

	handleClose(): void {
		this.setState({
			open: false
		});
	}

	render(): JSX.Element {
		const { error } = this.props;
		const { open } = this.state;
		return (
			<Dialog
				open={open}
				onClose={this.handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{'Interner Fehler'}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Ups, da ist etwas schiefgelaufen{error ? ': ' + error.displayMessage : ''}
					</DialogContentText>
				</DialogContent>
			</Dialog>
		);
	}
}

export default AuthErrorDialogView;
